import React from "react";
import { useTheme } from "styled-components";

export const IndeterminateIcon = (props: React.HTMLAttributes<HTMLDivElement>) => {
    const theme = useTheme();

    return <div {...props} style={{ height: "2px", width: "80%", backgroundColor: "white", borderRadius: theme.radius.xxs }} />;
};
